import { render, staticRenderFns } from "./SymbolsModal.vue?vue&type=template&id=24149ef2&scoped=true"
import script from "./SymbolsModal.vue?vue&type=script&lang=js"
export * from "./SymbolsModal.vue?vue&type=script&lang=js"
import style0 from "./SymbolsModal.vue?vue&type=style&index=0&id=24149ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24149ef2",
  null
  
)

export default component.exports